import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import LineChart from 'components/App/LineChart';
import { formatNumber } from 'utils/currencyFormat';

import styles from './OrderChart.module.scss';

function OrderChart({
  chartData,
  stayNightsChartData,
  calculatedAt,
  totalRoomNights,
  compareLabel = 'cùng phân khúc',
}) {
  const calculatedDateStr = React.useMemo(
    () => (calculatedAt ? moment(calculatedAt).format('D/M/YYYY') : '-'),
    [calculatedAt],
  );

  const legendItems = React.useMemo(() => [
    { label: 'Đặt trước của tôi', color: '#165DFF' },
    { label: `Đặt trước ${compareLabel}`, color: '#00BBFF' },
    { label: 'Giá bình quân của tôi', color: '#FF7A00' },
    { label: `Giá bình quân ${compareLabel}`, color: '#2CC4A2' },
  ], [compareLabel]);

  const legendItemsStayNights = React.useMemo(() => [
    { label: 'Số đêm lưu trú tối thiểu của tôi', color: '#165DFF' },
    { label: `Số đêm lưu trú tối thiểu ${compareLabel}`, color: '#00BBFF' },
    { label: 'Giá bình quân của tôi', color: '#FF7A00' },
    { label: `Giá bình quân ${compareLabel}`, color: '#2CC4A2' },
  ], [compareLabel]);

  return (
    <div className={styles.Container}>
      <div className="">
        <div className={styles.FlexDashboard}>
          <h2 className={styles.h2Title}>Số đêm đặt trước (%)</h2>
          <div className={styles.legend}>
            {legendItems.map((item) => (
              <div key={item.label} className={styles.item}>
                <div
                  className={styles.dot}
                  style={{ backgroundColor: item.color }}
                />
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.ChartWrapper}>
          <div className={styles.ChartScroll}>
            <LineChart
              data={chartData}
              peerBookingName={`Đặt trước ${compareLabel}`}
              peerPriceName={`Giá bình quân ${compareLabel}`}
            />
          </div>
        </div>
      </div>

      <div className={styles.SecondChart}>
        <div className={styles.FlexDashboard}>
          <h2 className={styles.h2Title}>Số đêm lưu trú tối thiểu</h2>
          <div className={styles.legend}>
            {legendItemsStayNights.map((item) => (
              <div key={item.label} className={styles.item}>
                <div
                  className={styles.dot}
                  style={{ backgroundColor: item.color }}
                />
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.ChartWrapper}>
          <div className={styles.ChartScroll}>
            <LineChart
              data={stayNightsChartData}
              myBookingName="Số đêm lưu trú tối thiểu của tôi"
              peerBookingName={`Số đêm lưu trú tối thiểu ${compareLabel}`}
              myPriceName="Giá bình quân của tôi"
              peerPriceName={`Giá bình quân ${compareLabel}`}
            />
          </div>
        </div>
      </div>

      <p className={styles.Caption}>
        Dữ liệu tính đến ngày
        {' '}
        {calculatedDateStr}
        {' '}
        với
        {' '}
        {formatNumber(totalRoomNights) || '-'}
        {' '}
        lượt đặt phòng
      </p>
    </div>
  );
}

OrderChart.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      myBooking: PropTypes.number,
      peerBooking: PropTypes.number,
      myPrice: PropTypes.number,
      peerPrice: PropTypes.number,
    }),
  ),
  stayNightsChartData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      myBooking: PropTypes.number,
      peerBooking: PropTypes.number,
      myPrice: PropTypes.number,
      peerPrice: PropTypes.number,
    }),
  ),
  calculatedAt: PropTypes.string,
  totalRoomNights: PropTypes.number,
  compareLabel: PropTypes.string,
};

OrderChart.defaultProps = {
  chartData: [],
  stayNightsChartData: [],
  calculatedAt: '',
  totalRoomNights: undefined,
  compareLabel: 'cùng phân khúc',
};

export default React.memo(OrderChart);
